module.exports = __webpack_public_path__ + "img/about-hero.ae453654.png";